import { createElement } from 'react';
import { string, bool, oneOfType, func, object, array } from 'prop-types';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import Text from '../Text/index.js';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import _Radio, { HiddenRadio, RadioIcon, RadioGroup as RadioGroup$1 } from './styled.js';

var Radio = function Radio(_ref) {
  var a11yId = _ref.a11yId,
      autoFocus = _ref.autoFocus,
      checked = _ref.checked,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      isRequired = _ref.isRequired,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      name = _ref.name,
      radioRef = _ref.radioRef,
      state = _ref.state,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "autoFocus", "checked", "className", "defaultChecked", "disabled", "isRequired", "label", "onBlur", "onChange", "onFocus", "name", "radioRef", "state", "value"]);

  return createElement(_Radio, _extends({
    "aria-describedby": "label",
    "aria-invalid": state === 'danger',
    "aria-label": label,
    "aria-required": isRequired
  }, props), createElement(HiddenRadio, {
    autoFocus: autoFocus,
    checked: checked,
    elementRef: radioRef,
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: a11yId,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    name: name,
    state: state,
    type: "radio",
    value: value
  }), createElement(RadioIcon, {
    state: state
  }), createElement(Text, {
    id: "label",
    htmlFor: a11yId,
    marginLeft: "minor-2"
  }, label));
};
Radio.Formik = formikField(Radio, {
  isCheckbox: true
});
Radio.ReduxForm = reduxFormField(Radio, {
  isCheckbox: true
});
var radioPropTypes = {
  a11yId: string,
  autoFocus: bool,
  checked: oneOfType([bool, string]),
  className: string,
  defaultChecked: bool,
  disabled: bool,
  isRequired: bool,
  label: string.isRequired,
  onBlur: func,
  onChange: func,
  onFocus: func,
  name: string,
  radioRef: object,
  state: string,
  value: string
};
Radio.propTypes = radioPropTypes;
var radioDefaultProps = {
  a11yId: undefined,
  autoFocus: false,
  checked: undefined,
  className: undefined,
  defaultChecked: undefined,
  disabled: false,
  isRequired: false,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  name: undefined,
  radioRef: undefined,
  state: undefined,
  value: undefined
};
Radio.defaultProps = radioDefaultProps; // @ts-ignore

var C = Radio;

var RadioGroup = function RadioGroup(_ref) {
  var a11yId = _ref.a11yId,
      a11yLabel = _ref.a11yLabel,
      className = _ref.className,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      options = _ref.options,
      name = _ref.name,
      state = _ref.state,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "a11yLabel", "className", "defaultValue", "disabled", "onChange", "options", "name", "state", "value"]);

  return createElement(RadioGroup$1, _extends({
    "aria-describedby": "label",
    "aria-invalid": state === 'danger',
    "aria-label": a11yLabel,
    role: "group"
  }, props), options.map(function (option, i) {
    return createElement(C, {
      key: i // eslint-disable-line
      ,
      a11yId: a11yId,
      checked: typeof value === 'undefined' ? undefined : option.value === value,
      defaultChecked: typeof defaultValue === 'undefined' ? undefined : option.value === defaultValue,
      disabled: disabled || option.disabled,
      name: name,
      label: option.label,
      onChange: onChange,
      radioRef: option.radioRef,
      state: state,
      value: option.value
    });
  }));
};
RadioGroup.Formik = formikField(RadioGroup);
RadioGroup.ReduxForm = reduxFormField(RadioGroup);
var radioGroupPropTypes = {
  a11yId: string,
  a11yLabel: string,
  className: string,
  defaultValue: string,
  disabled: bool,
  isHorizontal: bool,
  name: string.isRequired,
  options: array.isRequired,
  state: string,
  value: string,
  onChange: func
};
RadioGroup.propTypes = radioGroupPropTypes;
var radioGroupDefaultProps = {
  a11yId: undefined,
  a11yLabel: undefined,
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  isHorizontal: false,
  onChange: undefined,
  state: undefined,
  value: undefined
};
RadioGroup.defaultProps = radioGroupDefaultProps; // @ts-ignore

var C$1 = RadioGroup;

export { C$1 as a, radioGroupPropTypes as b, radioGroupDefaultProps as c, C as d, RadioGroup as e, radioPropTypes as f, radioDefaultProps as g };
